import React from 'react';

import { SeoFooterContent } from '~/common/components/SeoFooterContent/SeoFooterContent';

import type { DynamicSearchContent, SearchFilters } from '~/common/types/search';

type Props = {
  content: DynamicSearchContent;
  searchFilters: SearchFilters;
};

export const DynamicSeoContent = ({ content, searchFilters }: Props): React.ReactElement => (
  <SeoFooterContent content={content} searchFilters={searchFilters} />
);
